import * as styles from '../components/dueDates.scss';
import { observableToday } from 'owa-observable-datetime';
import { OwaDate, differenceInCalendarDays } from 'owa-datetime';

export default function getDueDateStyle(date: OwaDate | null | undefined, isCompleted: boolean) {
    if (isCompleted) {
        return styles.completed;
    }

    if (!date) {
        return '';
    }

    const diff = differenceInCalendarDays(date, observableToday());
    if (diff <= 0) {
        return styles.todayAndPast;
    }

    return styles.future;
}
